import { render, staticRenderFns } from "./seller-2.vue?vue&type=template&id=49fd61cc"
import script from "./seller-2.vue?vue&type=script&lang=js"
export * from "./seller-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports